module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "查看上课情况",
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.cancelAbsent
    }
  }, [_vm._v("取消学生旷课")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a957bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/detail/LessonMemberTimeModal.vue
// module id = 1687
// module chunks = 8